import { Group } from '@/components/_common';
import { usePortoBatteryWarranty } from '@/core/domain/porto/battery/battery.hooks';
import { Statistic, Button, Modal, Descriptions, Tooltip } from 'antd';
import { useWorkorderDetailContext } from '../../../WorkorderDetailProvider';
import { useCallback } from 'react';

interface Props {
  portoBatteryLabelCode?: string | null;
}

export default function WorkOrderItemPortoBatteryLabelCode(props: Props) {
  const batteryWarranty = usePortoBatteryWarranty();

  const {
    workorder: { data: workOrder },
  } = useWorkorderDetailContext();

  const openModalInfo = useCallback(async () => {
    try {
      let result = batteryWarranty.data;

      if (!result) {
        result = await batteryWarranty.mutateAsync({
          labelCode: props.portoBatteryLabelCode,
          qrCode: props.portoBatteryLabelCode,
        });
      }

      Modal.confirm({
        title: <strong>Garantia da bateria</strong>,
        icon: null,
        width: 500,
        okButtonProps: { style: { display: 'none' } },
        cancelText: 'Fechar',
        content: (
          <>
            <Descriptions
              column={1}
              layout="horizontal"
              labelStyle={{ fontWeight: 500 }}
              contentStyle={{ fontWeight: 600 }}
              style={{ marginTop: 24 }}
            >
              <Descriptions.Item label="Marca">
                {result.brand}
              </Descriptions.Item>
              <Descriptions.Item label="Código CAPS">
                {result.capsCode}
              </Descriptions.Item>
              <Descriptions.Item label="Nome CAPS">
                {result.capsName}
              </Descriptions.Item>
              <Descriptions.Item label="Código da Etiqueta">
                {result.labelCode}
              </Descriptions.Item>
              <Descriptions.Item label="Placa do Veículo">
                {result.licensePlate}
              </Descriptions.Item>
              <Descriptions.Item label="Fabricante">
                {result.manufacturer}
              </Descriptions.Item>
              <Descriptions.Item label="Modelo">
                {result.model}
              </Descriptions.Item>
              <Descriptions.Item label="Número da OS">
                {result.osNumber}
              </Descriptions.Item>
              <Descriptions.Item label="Protocolo">
                {result.protocol}
              </Descriptions.Item>
              <Descriptions.Item label="QR-Code">
                {result.qrCode}
              </Descriptions.Item>
              <Descriptions.Item label="Número da Solicitação">
                {result.requestNumber}
              </Descriptions.Item>
              <Descriptions.Item label="Número de Série">
                {result.serialNumber}
              </Descriptions.Item>
              <Descriptions.Item label="Status">
                {result.status ? 'OK' : 'Não OK'}
              </Descriptions.Item>
              <Descriptions.Item label="Data de Garantia">
                {result.warrantyDate}
              </Descriptions.Item>
            </Descriptions>
          </>
        ),
      });
    } catch {}
  }, [batteryWarranty.data, props.portoBatteryLabelCode]);

  return (
    <Group gap={24}>
      <Statistic
        title="Código da etiqueta"
        value={props?.portoBatteryLabelCode || 'Sem informação'}
      />

      <Tooltip
        title={
          !workOrder?.batteryWarrantyRegistered
            ? 'Sem emissão de garantia'
            : undefined
        }
      >
        <Button
          loading={batteryWarranty.isLoading}
          onClick={openModalInfo}
          disabled={!workOrder?.batteryWarrantyRegistered}
        >
          Visualizar
        </Button>
      </Tooltip>
    </Group>
  );
}
